import { render, staticRenderFns } from "./ORingErrorTypes.vue?vue&type=template&id=ec06e2d6&scoped=true"
import script from "./ORingErrorTypes.vue?vue&type=script&lang=ts"
export * from "./ORingErrorTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec06e2d6",
  null
  
)

export default component.exports